import _ from 'underscore';
import { CONTEXTUAL_ENTITY_TYPE } from '@bingads-webui-campaign/recommendation-core';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { withContextualAttributeTemplate } from '@bingads-webui-campaign/recommendation-contextual-attribute';

import template from './ad-group-column.pug';

export class AdGroupColumn extends ProjectionGridBaseColumn {
  constructor({
    i18n, view, deps: { appConfig, jsdata, dataManager },
  }) {
    super({
      name: 'AdGroup',
      property: 'Target/AdGroupName',
      title: i18n.getString('Entity_Adgroup'),
      bodyClasses: ['grid-column-adGroupName', 'actionable'],
      colClasses: ['col-longText'],
      sortable: 'Target/AdGroupName',
      type: 'string',
    });

    this.i18n = i18n;
    this.view = view;
    this.appConfig = appConfig;
    this.jsdata = jsdata;
    this.dataManager = dataManager;
  }

  template({
    value: {
      Opportunities,
      Target: { AdGroupName, AdGroupId, CampaignId },
    },
  }) {
    if (_.isEmpty(AdGroupName)) {
      return '--';
    }
    return template({
      adGroupAttributes: withContextualAttributeTemplate({
        opportunityId: Opportunities[0].OpportunityId,
        entityName: AdGroupName,
        entityId: AdGroupId,
        entityCampaignId: CampaignId,
        entityType: CONTEXTUAL_ENTITY_TYPE.ADGROUP,
        status: 'false',
        ariaLabel: this.i18n.getString('Click to scope to ad group {{adGroupName}}', { adGroupName: AdGroupName }),
      }),
    });
  }

  get property() {
    return {
      get: _.identity,
      property: 'Target/AdGroupName',
    };
  }
}
